/*global jQuery,document,window,WebFont*/
jQuery(document).ready(function ($) {
	"use strict";

	//vars
	var header = $('header'),
		headerTop = header.offset().top;

	WebFont.load({
		google: {
			families: ['Roboto:700,900', 'Roboto+Condensed:400,400i,700']
		},
		timeout: 1500
	});

	// Sticky header
	$(window).scroll(function () {
		if ($(window).scrollTop() >= headerTop) {
            $('html').addClass('scrolled');
        } else {
            $('html').removeClass('scrolled');
        }
	});

	// Mobile menu toggle
	$('.menu-toggle').click(function () {
		$('html').toggleClass('menu-open');
		$('nav').toggleClass('open');
	});

	// Prevent default on '#' anchors
	$('a[href="#"]').on('click', function (e) {
		e.preventDefault();
	});

	// Sub-menu toggle
	$('.menu li.menu-item-has-children > a').click(function () {
//		e.preventDefault();
		$('.menu li.menu-item-has-children > a').not(this).removeClass('open');
		$(this).toggleClass('open');
		$(this).next('.sub-menu').slideToggle(200);

		$('.menu li.menu-item-has-children .sub-menu').not($(this).next('.sub-menu')).slideUp(200);
	});

	// Initialize Featherlight Gallery
	$('.gallery-item a').featherlightGallery();

	// Modal Popup
	if ($(".staff-modal")[0]) {
		$(document.body).append("<div id='modal-box' style='display: none;'></div>");
	}
	$('#modal-box').click(function (e) {
		if (e.target !== this) {
			return;
		}
		$(this).fadeOut();
		$('html').removeClass('no-scroll');
	});
	$('.staff').click(function (e) {
		e.preventDefault();
		var staffID = $(this).attr('data-id'),
			staffContent = $('div#' + staffID).html();
		$('html').addClass('no-scroll');
		$('#modal-box').html(staffContent).fadeIn();
	});

	// Animations
	$('.animate-on-scroll').waypoint({
		handler: function () {
			$(this.element).addClass('animate');
		},
		offset: '100%'
	});
	$('.animate-on-load').addClass('animate');

	//	Hide all FAQ content except for the first item
	$('.faq').not(":first").find('.faq-answer').hide();
	$('.faq').find('.faq-question').click(function () {

		// Expand or collapse this panel
		$(this).next().slideToggle(200);
		$(this).toggleClass('faq-open');

		// Hide the other panels
		$('.faq-answer').not($(this).next()).slideUp(200);
		$('.faq-question').not($(this)).removeClass('faq-open');
	});

});